
import BalanceOverview from "@/components/balance_sheet/BalanceSheetOverview";
import BalanceSheetGraph from "@/components/balance_sheet/BalanceSheetGraph";
import ProfitAndLossRawData from "@/components/profit_and_loss/ProfitAndLossRawData";
import { useBalanceSheetOverview } from "@/hooks/use-balance-sheet-overview";
import { useBalanceSheetMonthly } from "@/hooks/use-balance-sheet-monthly";
import { useBalanceSheetVoucherRows } from "@/hooks/use-balance-sheet-voucher-rows";
import FinancialPage from "@/components/FinancialPage";
import { useTranslation } from "react-i18next";

const BalanceSheetModule = () => {
  const { t } = useTranslation();

  return (
    <FinancialPage
      title={t("balance_sheet:title")}
      showMonthly={false}
      overviewHook={useBalanceSheetOverview}
      graphHook={useBalanceSheetMonthly}
      rawHook={useBalanceSheetVoucherRows}
      OverviewComponent={BalanceOverview}
      GraphComponent={BalanceSheetGraph}
      RawComponent={ProfitAndLossRawData}
    />
  )
};

export default BalanceSheetModule;